import {
  GET_CURRENCY,
  SET_CURRENCY,
  CURRENCY_ERROR,
  LOADING_CURRENCY
} from "./types";
import axios from "axios";
export const getCurrency = () => async dispatch => {
  dispatch({
    type: LOADING_CURRENCY
  });
  try {
    let currency = localStorage.getItem("currency") || null;
    let currencyLayer = null;
    const { data } = await axios.post(
      `${process.env.REACT_APP_apiUrl}/getCurrency`
    );
    currencyLayer = data;
    dispatch({
      type: GET_CURRENCY,
      payload: { currency, currencyLayer }
    });
  } catch (error) {
    dispatch({
      type: CURRENCY_ERROR,
      payload: error.message
    });
  }
};

export const setCurrency = value => async dispatch => {
  dispatch({
    type: LOADING_CURRENCY
  });
  try {
    localStorage.setItem("currency", value);
    let currency = localStorage.getItem("currency");
    let currencyLayer = null;
    if (currency === "USD") {
      const { data } = await axios.post(
        `${process.env.REACT_APP_apiUrl}/getCurrency`
      );
      currencyLayer = data;
    }
    dispatch({
      type: SET_CURRENCY,
      payload: { currency, currencyLayer }
    });
  } catch (error) {
    dispatch({
      type: CURRENCY_ERROR,
      payload: error.message
    });
  }
};
